import React from "react";
import { Time } from "./time";

// "Last run" cell on the Sources page.
export default function RunSummary({ run }) {
  if (!run) return <span style={{ color: "var(--hs-text-muted)" }}>never run</span>;
  // "abandoned" (the process stopped mid-run) is shown like "error"
  const color = run.status === "ok" ? "var(--hs-safe)" : run.status === "running" ? "var(--hs-accent)" : "var(--hs-danger)";
  const skipped = run.skipped || 0;
  return (
    <div style={{ fontSize: 12 }} data-testid="run-summary">
      <span style={{ color }}>{run.status}</span> · {run.mode === "refetch" ? "refetch" : run.trigger} · <Time value={run.finished_at || run.started_at} />
      <div style={{ color: "var(--hs-text-muted)" }}>
        fetched {run.fetches ?? 0} · new {run.items_new ?? 0} · changed {run.items_changed ?? 0} · removed {run.items_removed ?? 0}
        {run.restored > 0 && <> · restored {run.restored}</>}
      </div>
      {skipped > 0 && (
        <div style={{ color: "var(--hs-warning)" }} data-testid="run-skipped">
          skipped {skipped} ({run.skipped_timeouts || 0} timeouts)
        </div>
      )}
      {run.stopped_early && <div style={{ color: "var(--hs-danger)" }} data-testid="run-stopped-early">stopped early: too many consecutive failures</div>}
      {(run.errors || []).length > 0 && (
        <div style={{ color: "var(--hs-danger)" }}>
          {run.errors[0]}{(run.errors_total || run.errors.length) > 1 ? ` (+${(run.errors_total || run.errors.length) - 1} more)` : ""}
        </div>
      )}
    </div>
  );
}
